import * as Colors from './colors';
import * as Spacing from './spacing';
import * as Fonts from './fonts';

export {Fonts, Spacing, Colors};
export const allColors = {...Colors};
